/**
 * Contains Router Paths in the application
*/
import Vue from 'vue'
import VueRouter from 'vue-router'
import middlewares from "../middlewares/index";
import Error404 from "../views/errors/404";
import Error403 from "../views/errors/403";
// import Index from "../views/Index";
// import Home from "../views/home/Index";
// import User from "../views//users/Index";
// import Groups from "../views/groups/Index";
// import Courses from "../views/courses/Index";
// import Reports from "../views/reports/Index";
// import ControlPanel from "../views/control-panel/Index";
// import CompanyAccountHome from "../views/company-account/Index";
import MakePayment from "../views/public/company/Index";
import MakePaymentSuccess from "../views/public/company/PurchaseSuccess";
import MakePaymentFail from "../views/public/company/PurchaseFail"

import WebShop from "../views/company-account/WebShop";
import SignUpForms from "../views/company-account/SignUpForms";
import Subscription from "../views/company-account/Subscription";
import CompanyProfile from "../views/company-account/CompanyProfile";
import CustomerPortal from "../views/company-account/CustomerPortal";

import UserSignUpFrom from "../views/public/signup-forms/Index"
import Login from "../views/public/login"
import RequestPasswordReset from "../views/public/request-password-reset"
import AdminDashboard from "../views/admin/dashboard"
import AdminManageCustomers from "../views/admin/manage_customers"
import AdminManageSettings from "../views/admin/settings"
import WebShopPublic from "../views/public/company/WebShopPublic";
import WebShopPayment from "../views/public/company/webshop/Payment";
import ContinueAbandonedPayment from "../views/public/company/webshop/ContinueAbandonedPayment";
import ContinueAbandonedPaymentSuccess from "../views/public/company/webshop/ContinueAbandonedPaymentSuccess";
import ContinueAbandonedPaymentFail from "../views/public/company/webshop/ContinueAbandonedPaymentFail";
import WebShopPurchaseSuccess from "../views/public/company/webshop/PurchaseSuccess";
import WebShopPurchaseFail from "../views/public/company/webshop/PurchaseFail";
import CustomerManagement from "../views/company-account/CustomerManagement";
import CustomerProfile from "../views/company-account/CustomerProfile";

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: Error404,
  },
  {
    path: '/403',
    component: Error403,
    name: "ForbiddenErrorPage"
  },
  // {
  //   path: '/',
  //   component: Index,
  // },
  // {
  //   path: '/home',
  //   component: Home,
  // },
  // {
  //   path: '/user',
  //   component: User,
  // },
  // {
  //   path: '/groups',
  //   component: Groups,
  // },
  // {
  //   path: '/courses',
  //   component: Courses,
  // },
  // {
  //   path: '/reports',
  //   component: Reports,
  // },
  // {
  //   path: '/control-panel',
  //   component: ControlPanel,
  //   beforeEnter : middlewares.checkAuth,
  // },
  {
    path: '/company-account/makepayment/:slug/:priceslug',
    component: MakePayment,
    name: 'CompanyMakePayment',

  },

  {
    path: '/company-account/customerportal',
    component: CustomerPortal,
    name: 'CompanyCustomerPortal',

  },
  {
    path: '/company-account/makepayment/purchase/subscription/success/:id/:type',
    component: MakePaymentSuccess,
    name: 'CompanyMakePaymentSuccess',

  },
  {
    path: '/company-account/makepayment/purchase/subscription/failed/:id/:type',
    component: MakePaymentFail,
    name: 'CompanyMakePaymentFail',

  },
  {
    path: '/company-account/webshop/:courseId/:instanceId/:sessionId',
    component: WebShopPayment,
    name: 'CompanyWebshopPayment',
  },
  {
    path: '/company-account/webshop/continue/payment/:paymentId/:instanceId',
    component: ContinueAbandonedPayment,
    name: 'ContinueCompanyWebshopPayment',
  },
  {
    path: '/company-account/webshop/purchase/abandonedsubscription/success/:id/:type/:connectedAccount',
    component: ContinueAbandonedPaymentSuccess,
    name: 'CompanyWebshopPaymentSuccess',

  },
  {
    path: '/company-account/webshop/purchase/abandonedsubscription/failed/:id/:type/:connectedAccount',
    component: ContinueAbandonedPaymentFail,
    name: 'CompanyWebshopPaymentFail',

  },
  {
    path: '/company-account/webshop/purchase/subscription/success/:id/:type/:connectedAccount',
    component: WebShopPurchaseSuccess,
    name: 'CompanyWebshopPaymentSuccess',

  },
  {
    path: '/company-account/webshop/purchase/subscription/failed/:id/:type/:connectedAccount',
    component: WebShopPurchaseFail,
    name: 'CompanyWebshopPaymentFail',

  },
  {
    path: '/company-account/subscription',
    name: 'CompanyAccountSubscription',
    component: Subscription,
    beforeEnter: middlewares.checkAuth,
  },
  {
    path: '/company-account/customer-management',
    name: 'CustomerManagement',
    component: CustomerManagement,
  },
  {
    path: '/company-account/customer-profile/:id',
    name: 'CustomerProfile',
    component: CustomerProfile,
    //beforeEnter: middlewares.checkAuth,
  },
  {
    path: '/company-account/company-profile',
    name: 'CompanyAccountProfile',
    component: CompanyProfile,
    beforeEnter: middlewares.checkAuth,
  },
  {
    path: '/company-account/sign-up-forms',
    name: 'CompanyAccountSignupForms',
    component: SignUpForms,
    beforeEnter: middlewares.checkAuth,
  },
  {
    path: '/company-account/web-shop',
    name: 'CompanyAccountWebShop',
    component: WebShop,
    beforeEnter: middlewares.checkAuth,
  },
  {
    path: '/company-account/web-shop/public/:instance_id/:product_id',
    name: 'WebShopPublic',
    component: WebShopPublic,
  },
  {
    path: '/login',
    component: Login,
    name: 'Login'
  },
  {
    path: '/password-reset',
    component: RequestPasswordReset,
    name: 'RequestPasswordReset'
  },
  {
    path: '/admin/',
    component: AdminDashboard,
    name: 'adminDashboard'
  },
  {
    path: '/admin/customers',
    component: AdminManageCustomers,
    name: 'adminManageCustomers',
    beforeEnter: middlewares.softCheckAuth,
  },
  {
    path: '/admin/settings',
    component: AdminManageSettings,
    name: 'adminManageSettings',
    beforeEnter: middlewares.softCheckAuth,
  },
  {
    path: '/signup/form/:formId',
    component: UserSignUpFrom,
    name: 'userSignupForm'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
